<template>
    <Select ref="selectModal" placeholder="请输入短剧名称进行搜索" :default-label="name" :value="name ? Number(value) : ''" :disabled="disabled"
            @on-change="$emit('change',$event)" clearable filterable :remote-method="handleGetPlay" :loading="playLoading">
            <Option v-for="(item, index) in playList" :key="index" :value="item.id"  :label="item.playName">{{ item.playName }}
                <div style="width: 1000px;flex-shrink:0"></div>
                {{ item.chineseName }}
            </Option>
          </Select>
</template>

<script>
import { getPlayList } from '@/api/play'
import { debounce } from 'lodash'
export default {
    props: {
        name: '',
        value: {
            type: Number|String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    data(){
        return {
            playLoading:false,
            playList: []
        }
    },
    watch:{
        value(){
            if(!this.value){
                this.$refs.selectModal.clearSingleSelect()
            }
            
        }
    },
    methods:{
        handleGetPlay: debounce(function (query) {
            if (!query) {
                this.playList = []
                this.playLoading = false
            } else {
                this.playLoading = true
                getPlayList({
                current: -1,
                keyword: query,
                size: -1
                }).then(r => {
                this.playList = r.data.records
                this.playLoading = false
                })
            }
            }, 700)
    }
}
</script>

<style lang="less" scoped>
/deep/.ivu-select-item{
    display: flex;
    max-width: 400px;
    overflow: hidden;
}
</style>
